import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
    deleteMAKAB020,
    deletePAIAB020,
    getPAIAB020Download,
    postPAIAA010,
    postPAIAB020Clone,
    postPAIAB020List,
    postPAIAF010,
    putPAIAB020JumpUp,
    putPAIAB020Reset,
    putPAIAB020Toggle,
    getPAGAA000,
    postPAIAD010
} from '../../../services/Api';
import ApplyItem from '../../../shared/components/ApplyItem';
import Loader from '../../../shared/components/Loader';
import RecruitItem from '../../../shared/components/RecruitItem';
import SideNav from '../../../shared/components/SideNav';
import Tabs from '../../../shared/components/Tabs';
import { MESSAGE } from '../../../shared/constants/app';
import { decodeToken, formatDate, shouldDisplayMenu } from '../../../utils';
import PAEAA060 from '../../Recruit/PAEAA010/popupPAEAA060';
import { decodeHTML } from 'entities';

const PAIAA010 = () => {
    const [loading, setLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const navigate = useNavigate();
    const savedConditions = useSelector(({ PAEAA010 }) => PAEAA010.savedPAEAA010Conditions);
    const savedCondition = savedConditions[savedConditions.length - 1] || {};
    const savedPAEAA010History = useSelector(({ PAEAA010 }) => PAEAA010.savedPAEAA010History);


    const [dataPAEAA010, setDataPAEAA010] = useState([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [dataStatistics, setDataStatistics] = useState({});
    const [dataNews, setDataNews] = useState([]);
    const [dataApplies, setDataApplies] = useState([]);
    const [activePopup, setActivePopup] = useState(null);
    const [dataPAIAB020, setDataPAIAB020] = useState([]);
    const [dataPAIAF010, setDataPAIAF010] = useState([]);
    const [dataRecent, setDataRecent] = useState([]);
    const [dataChoice, setDataChoice] = useState([]);
    const [popupData, setPopupData] = useState(null);
    // const [activeContentIndex, setActiveContentIndex] = useState(null);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [menuData, setMenuData] = useState([]);

    // const [activeIndex, setActiveIndex] = useState(null);
    const [activeMap, setActiveMap] = useState({});

    const tabs = useMemo(
        () => [
            { label: '추천 공고', isActive: true },
            { label: '최근 본 공고', isActive: false },
        ],
        [],
    );

    const handleTabChange = useCallback((index) => {
        setActiveTabIndex(index);
    }, []);

    const getListData = () => {
        setLoading(true);
        // const startDateFormat =
        //     savedCondition.startStoreDate === '' ? null : moment(savedCondition.startStoreDate).format('YYYY-MM-DD');
        // const endDateFormat =
        //     savedCondition.endStoreDate === '' ? null : moment(savedCondition.endStoreDate).format('YYYY-MM-DD');
        // const options =
        //     savedCondition.checkedStoreValues && Object.keys(savedCondition.checkedStoreValues).length === 0
        //         ? null
        //         : savedCondition.checkedStoreValues;

        // const subwayNum = savedCondition.checkedStoreValues?.subwayNum || null;
        // const subwayPost = savedCondition.checkedStoreValues?.SubwayPost || null;
        // const expMin = savedCondition.checkedStoreValues?.ExpMin?.[0] || '';
        // const expMax = savedCondition.checkedStoreValues?.ExpMax?.[0] || '';
        let options = { ...savedCondition.checkedStoreValues };

        // const optionLikeRight =
        //     savedCondition.checkedLikeRightStoreValues &&
        //         Object.keys(savedCondition.checkedLikeRightStoreValues).length === 0
        //         ? null
        //         : savedCondition.checkedLikeRightStoreValues;
        // const method =
        //     savedCondition.applyMethodStore && savedCondition.applyMethodStore.length === 0
        //         ? null
        //         : savedCondition.applyMethodStore;

        delete options.SubwayPost;
        delete options.subwayNum;
        delete options.ExpMin;
        delete options.ExpMax;

        // if (savedConditions.length > 0) {
        //     postPABAA010recruit({
        //         options,
        //         optionLikeRight,
        //         applyMethod: method,
        //         startDate: startDateFormat,
        //         endDate: endDateFormat,
        //         subwayPost: Array.isArray(subwayPost)
        //             ? subwayPost.filter((post) => post !== '100')
        //             : subwayPost || null,
        //         subwayNum,
        //         expMin,
        //         expMax,
        //         size: 3,
        //         sortBy: 'ModDate',
        //     })
        //         .then(({ data }) => {
        //             setDataPAEAA010(data.data);
        //         })
        //         .catch((error) => console.log(error))
        //         .finally(() => {
        //             setLoading(false);
        //         });
        // }
        postPAIAD010()
            .then((response) => {
                setDataPAEAA010(response?.data?.data || []);
            })
            .catch((error) => console.log(error))
            .finally(() => setLoading(false));



        postPAIAA010(savedPAEAA010History)
            .then(({ data }) => {
                setDataStatistics(data.statistics);
                setDataNews(data.news);
                setDataApplies(data.applies);
                setDataChoice(data.choices);
                setDataRecent(data.recent);
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [
        savedCondition.applyMethodStore,
        savedCondition.checkedLikeRightStoreValues,
        savedCondition.checkedStoreValues,
        savedCondition.endStoreDate,
        savedCondition.startStoreDate,
        savedPAEAA010History,
    ]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                setMenuData(data);
            })
            .catch((error) => console.log(error));

        const fetchData = async () => {
            try {
                const { data } = await postPAIAB020List({ size: 3 });
                setDataPAIAB020(data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);

    const handleResumeLvl = async (seq, resumeLvl) => {
        const isPublic = resumeLvl === 'Y';
        const confirmMsg = isPublic
            ? '이력서를 비공개로 변경하시겠습니까?'
            : '공개로 변경하면 현재 공개중인 이력서가 있을 경우 비공개로 변경됩니다.\n이력서를 공개로 변경하시겠습니까?';

        if (window.confirm(confirmMsg)) {
            try {
                await putPAIAB020Toggle(seq);
                const { data } = await postPAIAB020List();
                setDataPAIAB020(data.data);
                window.alert(isPublic ? '비공개로 변경되었습니다.' : '공개로 변경되었습니다.');
            } catch (error) {
                console.error(error);
                window.alert(MESSAGE.notify.updateError);
            }
        }
    };

    const handleDelete = async (seq) => {
        const isConfirm = window.confirm(
            '삭제된 이력서는 복구가 불가능합니다.\n정말 삭제하시겠습니까?',
        );
        if (isConfirm) {
            try {
                await deletePAIAB020(seq);
                const { data } = await postPAIAB020List();
                setDataPAIAB020(data.data);
                window.alert(MESSAGE.notify.deleteSuccess);
            } catch (error) {
                console.error(error);
                window.alert(MESSAGE.notify.deleteError);
            }
        }
    };

    const handleDownload = async (seq, fileName) => {
        setLoading(true);
        try {
            await getPAIAB020Download(seq, fileName);
        } catch (error) {
            console.error(error);
            window.alert(MESSAGE.notify.downloadError);
        } finally {
            setLoading(false);
        }
    };

    const handleJumpUp = async (seq) => {
        try {
            await putPAIAB020JumpUp(seq);
            const { data } = await postPAIAB020List();
            alert('점프업되었습니다.');
            setDataPAIAB020(data.data);
        } catch (error) {
            console.error(error);
            window.alert(MESSAGE.notify.updateError);
        }
    };

    const handleReset = async (seq) => {
        try {
            await putPAIAB020Reset(seq);
            const { data } = await postPAIAB020List();
            setDataPAIAB020(data.data);
        } catch (error) {
            console.error(error);
            window.alert(MESSAGE.notify.updateError);
        }
    };

    const handleClone = async (seq) => {
        try {
            await postPAIAB020Clone(seq);
            const { data } = await postPAIAB020List();
            setDataPAIAB020(data.data);
        } catch (error) {
            console.error(error);
            window.alert(MESSAGE.notify.updateError);
        }
    };

    const handlePopup = (seq) => {
        setActivePopup((prev) => (prev === seq ? null : seq));
    };

    const refreshDataApplies = async () => {
        try {
            setLoading(true);
            postPAIAA010().then(({ data }) => {
                setDataApplies(data.applies);
            });
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const openPopup = (data) => {
        setPopupData(data);
        setIsPopupOpen(true);
    };
    const closePopup = () => {
        setIsPopupOpen(false);
    };

    // const handleActiveContent = (index) => {
    //     setActiveContentIndex((prevIndex) => (prevIndex === index ? null : index));
    // };

    const handleClickTitle = (item, index) => {
        setActiveMap(prev => ({
            ...prev,
            [index]: !(prev[index] ?? item?.contentView === 'Y'),
        }));
    };

    const getListDataPAIAF010 = () => {
        setLoading(true);
        postPAIAF010({ size: 3 })
            .then(({ data }) => {
                setDataPAIAF010(data.data);
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getListDataPAIAF010();
        // eslint-disable-next-line
    }, []);

    const handleDeletePAIAF010 = (seq) => {
        if (window.confirm(MESSAGE.confirm.delete)) {
            deleteMAKAB020(seq, decode?.memberID)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    getListDataPAIAF010();
                })
                .catch((error) => console.log(error));
        }
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!event.target.closest('.rsm-mng__popup') && !event.target.closest('.rsm-mng__menu')) {
                setActivePopup(null);
            }
        };

        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div style={{ width: '100%' }} id="statistic">
                            <div id="info-dashboard" className="frame-section">
                                {/* End Common User Info Setting */}
                                <div style={{ position: 'relative' }} className="contents">
                                    <ul>
                                        <li>
                                            <p>나의 이력서</p>
                                            <Link to="/paiab020" className="rsm-stt__num"><h1>{dataStatistics?.totalResume || 0}</h1></Link>
                                        </li>
                                        <li>
                                            <p>입사지원 현황</p>
                                            <Link to="/paiac010" className="rsm-stt__num"><h1>{dataStatistics?.totalApply || 0}</h1></Link>
                                        </li>
                                        <li>
                                            <p>스크랩한 공고</p>
                                            <Link to="/paiae010" className="rsm-stt__num"><h1>{dataStatistics?.totalChoiceRecruit || 0}</h1></Link>
                                        </li>
                                        <li>
                                            <p>새로운 쪽지</p>
                                            <Link to="/paiaf010" className="rsm-stt__num"><h1>{dataStatistics?.totalPropose || 0}</h1></Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {shouldDisplayMenu('pahaf010', menuData) && (
                                <div id="notification" className="frame-section">
                                    <div className="header-frame">
                                        <h1>공지사항</h1>
                                        <Link to="/pahaf010" className="top-link">
                                            공지사항 바로가기
                                        </Link>
                                    </div>
                                    <div className="content-frame">
                                        <ul>
                                            {dataNews?.length > 0 ? (
                                                dataNews.map((item, index) => {
                                                    const isActive = activeMap[index] ?? item?.contentView === 'Y';

                                                    return (
                                                        <li key={'news_' + index} className={isActive ? 'active' : ''}>
                                                            <h1 onClick={() => handleClickTitle(item, index)}>
                                                                {item?.title}
                                                                <span className="date" style={{ float: 'right', fontSize: '14px', marginRight: '10px', color: '#999' }}>{formatDate(item?.addDate)}</span>
                                                            </h1>

                                                            {isActive && (
                                                                <div
                                                                    className="notify-image"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item.content ? decodeHTML(item.content) : '',
                                                                    }}
                                                                />
                                                            )}
                                                        </li>
                                                    );
                                                })
                                            ) : (
                                                <li className="no-data">
                                                    {loading ? (
                                                        <p>
                                                            <Loader />
                                                        </p>
                                                    ) : (
                                                        '데이터없습니다.'
                                                    )}
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            <div id="status-support" className="frame-section">
                                <div className="header-frame">
                                    <h1>이력서 관리</h1>
                                    <Link to="/paiab020" className="top-link">
                                        이력서 관리 바로가기
                                    </Link>
                                </div>
                                <div className="content-frame">
                                    <table className="rsm-mng__table">
                                        <thead>
                                            <tr>
                                                <th>등록일</th>
                                                <th style={{ width: '55%' }}>제목</th>
                                                <th>조회수</th>
                                                <th>최종수정</th>
                                                <th>관리</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dataPAIAB020 && dataPAIAB020.length > 0 ? (
                                                dataPAIAB020.map((item) => (
                                                    <tr key={item.seq}>
                                                        <td>
                                                            <div className="rsm-mng__col">
                                                                <span>{formatDate(item.addDate)}</span>
                                                                <div
                                                                    onClick={() =>
                                                                        handleResumeLvl(item.seq, item.resumeLvl)
                                                                    }
                                                                    className={`rsm-mng__open ${item.resumeLvl === 'Y' ? 'active' : ''
                                                                        }`}
                                                                >
                                                                    {item.resumeLvl === 'Y' ? '공개' : '비공개'}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        {/* <td>
                                                            <button
                                                                type="button"
                                                                className={`rsm-mng__toggle ${item.resumeLvl === 'Y' ? 'active' : ''
                                                                    }`}
                                                                onClick={() => handleResumeLvl(item.seq)}
                                                            />
                                                        </td> */}
                                                        <td className="text-left title-resume-management">
                                                            <div className="wrap-title-resume">
                                                                <a
                                                                    href={`/paiab020-${item?.seq}`}
                                                                    className="twoLine-text"
                                                                    rel="nofollow"
                                                                    target="_self"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        window.open(
                                                                            `/paiab020-${item?.seq}`,
                                                                            '_blank',
                                                                            `width=1200,height=${window.screen.height}`,
                                                                        );
                                                                    }}
                                                                >
                                                                    {item.title}
                                                                </a>
                                                                {item.resumeLvl === 'Y' ? (
                                                                    <div
                                                                        className="dntInf__jump"
                                                                        onClick={() => handleJumpUp(item.seq)}
                                                                    >
                                                                        Jump up
                                                                    </div>
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>
                                                        </td>
                                                        {/* <td>
                                                            {item.resumeLvl === 'Y' ? (
                                                                <div
                                                                    className="dntInf__jump"
                                                                    onClick={() => handleJumpUp(item.seq)}
                                                                >
                                                                    Jump up
                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </td> */}
                                                        <td>
                                                            <div className="dntInf__view">
                                                                {item.visitedCnt}
                                                                <button
                                                                    type="button"
                                                                    className="dntInf__reset"
                                                                    onClick={() => handleReset(item.seq)}
                                                                >
                                                                    초기화
                                                                </button>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="rsm-mng__date">
                                                                {formatDate(item.modDate)}
                                                                <br />
                                                                {moment(item.modDate).locale('ko').format('HH:mm:ss')}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="rsm-mng__btbx2">
                                                                <div className="rsm-mng__lf">
                                                                    <button
                                                                        type="button"
                                                                        className="rsm-mng__btn2 rsm-mng__btn2--blue"
                                                                        onClick={() =>
                                                                            navigate(`/paiab010-${item.seq}`)
                                                                        }
                                                                    >
                                                                        <Link>수정</Link>
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="rsm-mng__btn2"
                                                                        onClick={() => handleClone(item.seq)}
                                                                    >
                                                                        복사
                                                                    </button>
                                                                </div>
                                                                <div
                                                                    className="rsm-mng__menu"
                                                                    onClick={() => handlePopup(item.seq)}
                                                                >
                                                                    <i></i>
                                                                    <i></i>
                                                                    <i></i>
                                                                </div>
                                                                {activePopup === item.seq && (
                                                                    <div className="rsm-mng__popup">
                                                                        <ul>
                                                                            <li>
                                                                                <button
                                                                                    onClick={() =>
                                                                                        handleDownload(
                                                                                            item.seq,
                                                                                            item.title,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {loading ? (
                                                                                        <p
                                                                                            style={{
                                                                                                width: '120.63px',
                                                                                            }}
                                                                                        >
                                                                                            <Loader size={15} />
                                                                                        </p>
                                                                                    ) : (
                                                                                        '워드파일로 다운로드'
                                                                                    )}
                                                                                </button>
                                                                            </li>
                                                                            <li>
                                                                                <button
                                                                                    onClick={() =>
                                                                                        handleDelete(item.seq)
                                                                                    }
                                                                                >
                                                                                    삭제
                                                                                </button>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7}>
                                                        {loading ? (
                                                            <p>
                                                                <Loader />
                                                            </p>
                                                        ) : (
                                                            '데이터없습니다.'
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div id="status-support" className="frame-section">
                                <div className="header-frame">
                                    <h1>지원현황</h1>
                                    <Link to="/paiac010" className="top-link">
                                        지원현황 바로가기
                                    </Link>
                                </div>
                                <div className="content-frame">
                                    <ul className="table table-content">
                                        <li className="row-name-column">
                                            <div className="column">치과명</div>
                                            <div className="column start">지원내역</div>
                                            <div className="column" style={{ width: 'max-content' }}>
                                                공고 진행상태
                                            </div>
                                            <div className="column">열람</div>
                                            <div className="column">지원결과</div>
                                            <div className="column">관리</div>
                                        </li>
                                        {dataApplies && dataApplies.length > 0 ? (
                                            dataApplies.map((item, index) => (
                                                <ApplyItem
                                                    key={`apply_${index}`}
                                                    item={item}
                                                    type={'li'}
                                                    onRefresh={refreshDataApplies}
                                                />
                                            ))
                                        ) : (
                                            <div className="no-data">
                                                {loading ? <Loader /> : '지원현황이 없습니다.'}
                                            </div>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div id="notification-tab" className="frame-section">
                                <Tabs tabs={tabs} className="short-tab" onTabChange={handleTabChange} />
                                <div
                                    className="header-table-container"
                                    style={{ marginTop: '20px', borderTop: '1px solid #111' }}
                                >
                                    <div className="table table-header">
                                        <div className="column column-1">치과명</div>
                                        <div className="column column-3">
                                            <div>
                                                <span className="text-bold">제목</span>
                                                /담당업무/위치
                                            </div>
                                            <div>경력/형태/자격증/수정</div>
                                            <div>마감일</div>
                                        </div>
                                    </div>
                                </div>
                                {activeTabIndex === 0 && (
                                    <ul className="table wrap-table wrap-table-tab">
                                        {dataPAEAA010 && dataPAEAA010.length > 0 ? (
                                            dataPAEAA010.map((item, index) => (
                                                <RecruitItem
                                                    item={item}
                                                    key={index}
                                                    openPopup={openPopup}
                                                    refreshData={getListData}
                                                    showStar={true}
                                                    roleAction="P"
                                                />
                                            ))
                                        ) : (
                                            <li className="no-data">
                                                {loading ? <Loader /> : '추천 공고 정보가 없습니다.'}
                                            </li>
                                        )}
                                    </ul>
                                )}
                                {activeTabIndex === 1 && (
                                    <ul className="table wrap-table wrap-table-tab">
                                        {dataRecent && dataRecent.length > 0 ? (
                                            dataRecent.map((item, index) => (
                                                <RecruitItem
                                                    item={item}
                                                    key={index}
                                                    openPopup={openPopup}
                                                    refreshData={getListData}
                                                    showStar={true}
                                                    roleAction="P"
                                                />
                                            ))
                                        ) : (
                                            <li className="no-data">
                                                {loading ? <Loader /> : '최근 본 공고가 없습니다.'}
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </div>

                            <div id="notification-tab" className="frame-section">
                                <div className="header-frame">
                                    <h1>스크랩</h1>
                                    <Link to="/paiae010" className="top-link">
                                        스크랩 바로가기
                                    </Link>
                                </div>
                                <div className="header-table-container">
                                    <div className="table table-header">
                                        <div className="column column-1">치과명</div>
                                        <div className="column column-3">
                                            <div>
                                                <span className="text-bold">제목</span>
                                                /담당업무/위치
                                            </div>
                                            <div>경력/형태/자격증/수정</div>
                                            <div>마감일</div>
                                        </div>
                                    </div>
                                </div>
                                <ul className="table wrap-table wrap-table-tab">
                                    {dataChoice && dataChoice.length > 0 ? (
                                        dataChoice.map((item, index) => (
                                            <RecruitItem
                                                item={{ ...item, isChoice: 'Y' }}
                                                key={index}
                                                openPopup={openPopup}
                                                refreshData={getListData}
                                                showStar={true}
                                                roleAction="P"
                                            />
                                        ))
                                    ) : (
                                        <li className="no-data">{loading ? <Loader /> : '스크랩 공고가 없습니다.'}</li>
                                    )}
                                </ul>
                            </div>

                            <div id="notification-tab" className="frame-section">
                                <div className="header-frame">
                                    <h1>쪽지</h1>
                                    <Link to="/paiaf010" className="top-link">
                                        쪽지 바로가기
                                    </Link>
                                </div>
                                <table className="msg__table" style={{ marginTop: '0', borderTop: '0' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20%%' }}>보낸사람</th>
                                            <th style={{ width: '50%' }}>내용</th>
                                            <th style={{ width: '20%' }}>발송일</th>
                                            <th style={{ width: '10%' }}>관리</th>
                                        </tr>
                                    </thead>
                                    <tbody className="msg__border-bottom">
                                        {dataPAIAF010 && dataPAIAF010.length > 0 ? (
                                            dataPAIAF010.map((item) => (
                                                <tr key={item.seq}>
                                                    <td
                                                        style={{
                                                            fontWeight: item.unreadCount > 0 ? 600 : '',
                                                        }}
                                                    >
                                                        {item.partnerGbn === 'C'
                                                            ? item.partnerCompany
                                                            : item.partnerGbn === 'P'
                                                                ? item.partnerName
                                                                : ''}
                                                    </td>
                                                    <td>
                                                        <div className="list-content-mess-wrap">
                                                            <Link
                                                                to={`/paiaf020-${item.seq}`}
                                                                className="list-content-mess"
                                                                style={{
                                                                    fontWeight: item.unreadCount > 0 ? 600 : '',
                                                                }}
                                                            >
                                                                <span>{item.latestContent}</span>
                                                            </Link>
                                                            {item.unreadCount > 0 && (
                                                                <span className="count-mess">{item.unreadCount}</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td
                                                        style={{
                                                            fontWeight: item.unreadCount > 0 ? 600 : '',
                                                        }}
                                                    >
                                                        {formatDate(item?.latestSendDate)}
                                                        <br />
                                                        {moment(item?.latestSendDate).format('HH:mm:ss')}
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="msg__delete"
                                                            onClick={() => handleDeletePAIAF010(item.seq)}
                                                        >
                                                            <i className="icon icon-trash-2"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4}>{loading ? <Loader /> : '데이터없습니다'}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* End Info Dashboard */}
                    </div>
                    {/* End Top Sub Page */}
                </div>
            </div>
            {isPopupOpen && <PAEAA060 closePopup={closePopup} popupData={popupData} />}
        </>
    );
};

export default PAIAA010;
